import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Confetti from "react-confetti";
import api from "src/store/features/api";
import usePermission from "src/utils/hooks/usePermission";
import { Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { trackEvent } from "src/Amplitude";

const WelcomeModal: React.FC = () => {
  const { data: userRes } = api.useGetUserDatav2Query();
  const [acceptedWelcomeModal] = api.useAcceptWelcomeModalMutation();
  const { isGuest } = usePermission();
  const { acceptWelcomeModal = true } = userRes || {};

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  const resizeListener = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  React.useEffect(() => {
    window.addEventListener("resize", resizeListener);
    return () => {
      window.removeEventListener("resize", resizeListener);
    };
  }, []);

  const closeModal = async () => {
    await acceptedWelcomeModal();
    trackEvent(`Guest Welcome Modal Closed`);
    setModalIsOpen(false);
  };

  useEffect(() => {
    if (!isGuest && !acceptWelcomeModal) {
      trackEvent(`Guest Welcome Modal Viewed`);
      setModalIsOpen(true);
    }
  }, [acceptWelcomeModal]);

  return (
    <div>
      <Modal
        open={modalIsOpen}
        onClose={closeModal}
        aria-labelledby="welcome-modal-title"
        aria-describedby="welcome-modal-description">
        <>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4.5,
              zIndex: "inherit",
            }}>
            <div style={{ display: "flex", justifyContent: "right" }}>
              <IconButton onClick={closeModal}>
                <Close />
              </IconButton>
            </div>
            <h2 style={{ margin: 0 }} id="welcome-modal-title">
              Welcome {userRes?.details.name} to the Caleb & Brown Portal.
            </h2>
            <p id="welcome-modal-description">
              You are now a verified client of ours with your own dedicated Broker.
            </p>
            <p id="welcome-modal-description">
              If you're ready to start trading, navigate to Deposit Fiat / Crypto to make your first
              deposit.
            </p>
            <p id="welcome-modal-description">
              Or if you'd like some more information about the industry, book in a call with your
              Broker or even check out our Research report.
            </p>
            <p id="welcome-modal-description">Thanks, and welcome again to Caleb & Brown.</p>
          </Box>
          {modalIsOpen && <Confetti width={width} height={height} numberOfPieces={500} />}
        </>
      </Modal>
    </div>
  );
};

export default WelcomeModal;
